export default "__VITE_ASSET__DUWWXSEP__"